import { useRef, useState, useEffect } from 'react';
import { useScroll } from 'framer-motion';
import { WaterHero } from '../components/sections/WaterHero';
import { ServiceStack } from '../components/sections/ServiceStack';
import { LocationParallax } from '../components/sections/LocationParallax';
import { WhyUs } from '../components/sections/WhyUs';
import { CTASection } from '../components/sections/CTASection';
import { FloatingShapes } from '../components/effects/ScrollEffects';
import { Pool3DSceneVanilla } from '../components/effects/Pool3DSceneVanilla';

export const HomePage = () => {
  const containerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [is3DSupported, setIs3DSupported] = useState(true);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start start', 'end end'],
  });

  // Detect mobile and WebGL support
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    // Check WebGL support
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      setIs3DSupported(!!gl);
    } catch (e) {
      setIs3DSupported(false);
    }
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <main ref={containerRef} data-testid="home-page" className="relative">
      {/* Real 3D Scene with Three.js vanilla - only on desktop with WebGL support */}
      {is3DSupported && !isMobile && <Pool3DSceneVanilla />}
      
      {/* Fallback floating shapes for mobile or no WebGL */}
      {(isMobile || !is3DSupported) && (
        <FloatingShapes scrollYProgress={scrollYProgress} />
      )}
      
      {/* Hero with water effects */}
      <WaterHero />
      
      {/* Services with card animations */}
      <ServiceStack />
      
      {/* Why choose us */}
      <WhyUs />
      
      {/* Location parallax */}
      <LocationParallax />
      
      {/* CTA Section */}
      <CTASection />
    </main>
  );
};

export default HomePage;
